module.exports = __webpack_public_path__ + "static/media/se_page6.e1ffdc90.ogg";